// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTv } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const TV: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faTv} />
//     </Graphics>
//     <Description>
//       This could buy you: <br />
//       <span>100+ years of Netflix</span>!
//     </Description>
//   </Fragment>
// );

// export default TV;
